import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Card,
  CardGroup,
  Table,
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link, useParams, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { TiPrinter } from "react-icons/ti";
import {
  getAllVisas,
  resetVisaList,
  getVisaById,
  deleteVisa,
  resetVisaDelete,
} from "../features/visa/visaSlice";
import { getAllPassports } from "../features/passport/passportSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import { logout } from "../features/user/userSlice";

const VisaList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [allVisas, setAllVisas] = useState([]);

  const [searchByVisaName, setSearchByVisaName] = useState("");
  const [searchByVisaType, setSearchByVisaType] = useState("");
  const [searchByCountry, setSearchByCountry] = useState("");

  //user Selector
  const { userInfo } = useSelector((state) => state.user);

  // Visa Selector
  const {
    visas,
    isListLoading,
    isListError,
    isListSuccess,
    listErrorMessage,

    isDeleteError,
    isDeleteLoading,
    isDeleteSuccess,
    deleteErrorMessage,
  } = useSelector((state) => state.visa);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login To Get Access!!", { position: "top-center" });
      navigate("/login");
    }
    if (userInfo.permissions?.includes("visaList") === false) {
      toast.error("Paknami Keno Koren???", {
        position: "top-center",
      });
      dispatch(logout());
    }
  }, [userInfo, navigate, dispatch]);

  useEffect(() => {
    if (isListError) {
      toast.error(listErrorMessage, { position: "top-center" });
    } else if (isListSuccess) {
      const filteredVisas = visas
        .filter((visa) => {
          if (searchByCountry === "") {
            return visa;
          } else {
            return visa.visaCountry
              .toLowerCase()
              .includes(searchByCountry.toLowerCase());
          }
        })
        .filter((visa) => {
          if (searchByVisaName === "") {
            return visa;
          } else {
            return visa.visaName
              .toLowerCase()
              .includes(searchByVisaName.toLowerCase());
          }
        })
        .filter((visa) => {
          if (searchByVisaType === "") {
            return visa;
          } else {
            return visa.visaType
              .toLowerCase()
              .includes(searchByVisaType.toLowerCase());
          }
        });
      setAllVisas(filteredVisas);
    } else {
      dispatch(getAllVisas());
    }
  }, [
    dispatch,
    isListError,
    isListSuccess,
    visas,
    searchByVisaName,
    searchByCountry,
    searchByVisaType,
  ]);

  useEffect(() => {
    if (isDeleteError) {
      toast.error(deleteErrorMessage, { position: "top-center" });
    } else if (isDeleteSuccess) {
      toast.success("Visa Deleted Successfully", { position: "top-center" });
      dispatch(getAllVisas());
    }
  }, [isDeleteError, isDeleteSuccess, deleteErrorMessage]);

  useEffect(() => {
    return () => {
      dispatch(resetVisaList());
      dispatch(resetVisaDelete());
    };
  }, []);

  return (
    <Container fluid className="my-4">
      <>
        {/* <h2 style={{ fontWeight: "bold" }} className="mb-4 text-center">
          All Visa List
        </h2> */}
        <Row className="mb-4">
          <Card
            className="rounded-4 border"
            style={{ backgroundColor: "#e6edf1" }}
          >
            <h2 className="my-3 text-dark text-center fw-bold">
              All <span style={{ color: "#5c91dc" }}>Visa</span> List
            </h2>
          </Card>
        </Row>

        {/* {isListLoading ? ( 
       <Loader />
       ) : (
        <> */}
        <Row>
          {/* Search By Country */}
          <CardGroup className="mb-3 p-0">
            <Card>
              <Card.Header
                className="text-center text-black fw-bold"
                style={{ backgroundColor: "#74a2e3" }}
                as="h6"
              >
                Search By Visa Name
              </Card.Header>
              <Card.Body>
                <Form>
                  <Form.Control
                    type="text"
                    placeholder="Search By Visa Name"
                    name="searchByVisaName"
                    //value={searchByVisaName}
                    onChange={(e) => setSearchByVisaName(e.target.value)}
                    className="shadow-rounded"
                  ></Form.Control>
                </Form>
              </Card.Body>
            </Card>

            <Card>
              <Card.Header
                className="text-center text-black fw-bold"
                style={{ backgroundColor: "#74a2e3" }}
                as="h6"
              >
                Search By Visa Type
              </Card.Header>
              <Card.Body>
                <Form>
                  <Form.Control
                    type="text"
                    placeholder="Search By Visa Type"
                    name="searchByVisaType"
                    //value={searchByVisaType}
                    onChange={(e) => setSearchByVisaType(e.target.value)}
                    className="shadow-rounded"
                  ></Form.Control>
                </Form>
              </Card.Body>
            </Card>

            <Card>
              <Card.Header
                className="text-center text-black fw-bold"
                style={{ backgroundColor: "#74a2e3" }}
                as="h6"
              >
                Search By Country
              </Card.Header>
              <Card.Body>
                <Form>
                  <Form.Control
                    type="text"
                    placeholder="Search By Country"
                    name="searchByCountry"
                    //value={searchByCountry}
                    onChange={(e) => setSearchByCountry(e.target.value)}
                    className="shadow-rounded"
                  ></Form.Control>
                </Form>
              </Card.Body>
            </Card>
          </CardGroup>
        </Row>

        {/* Visa List Table*/}
        <Row>
          <Card className="shadow px-2" style={{ backgroundColor: "#74a2e3" }}>
            <Card.Header
              className="text-center text-black fw-bold"
              as="h5"
              style={{ backgroundColor: "#74a2e3" }}
            >
              Visa List
            </Card.Header>

            <Table rounded bordered hover responsive style={{ padding: "0px" }}>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Visa Name</th>
                  {/* <th>Visa ID</th> */}
                  <th>Visa Number</th>
                  <th>Visa Type</th>
                  <th>Visa Country</th>
                  {/* <th>Profession</th>
              <th>Salary</th> */}
                  <th>Visa Office Name</th>
                  {/* <th>Visa Office Phone</th>
              <th>Visa Office Address</th> */}
                  <th>Visa Rate</th>
                  <th>Total Rate</th>
                  <th>Visa Contact Amount</th>
                  <th>Visa Paid Amount</th>
                  <th>Visa Due Amount</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>

              <tbody className="text-center">
                {allVisas.map((visa, index) => (
                  <>
                    <tr key={visa._id} style={{ cursor: "pointer" }}>
                      <td style={{ padding: "0px" }}>{index + 1}</td>
                      <td style={{ padding: "0px" }}>{visa.visaName}</td>
                      <td style={{ padding: "0px" }}>{visa.visaNumber}</td>
                      <td style={{ padding: "0px" }}>{visa.visaType}</td>
                      <td style={{ padding: "0px" }}>{visa.visaCountry}</td>
                      <td style={{ padding: "0px" }}>{visa.visaOfficeName}</td>
                      <td style={{ padding: "0px" }}>{visa.visaRate}</td>
                      <td style={{ padding: "0px" }}>{visa.totalRate}</td>
                      <td style={{ padding: "0px" }}>
                        {visa.visaContactAmount}
                      </td>
                      <td style={{ padding: "0px" }}>{visa.visaPaidAmount}</td>
                      <td style={{ padding: "0px" }}>
                        {visa.visaContactAmount - visa.visaPaidAmount}
                      </td>

                      {userInfo.userType === "admin" ? (
                        <>
                          <td style={{ padding: "0px" }}>
                            <LinkContainer to={`/updateVisa/${visa._id}`}>
                              <Button variant="info" className="btn-sm">
                                <FaEdit />
                              </Button>
                            </LinkContainer>
                          </td>
                          <td style={{ padding: "0px" }}>
                            <Button
                              className="btn-sm"
                              variant="danger"
                              onClick={() => dispatch(deleteVisa(visa._id))}
                            >
                              <MdDelete />
                            </Button>
                          </td>
                        </>
                      ) : (
                        <>
                          <td style={{ padding: "0px" }}>
                            {/* <LinkContainer to={`/visa/edit/${visa._id}`}> */}
                            <Button variant="info" className="btn-sm" disabled>
                              <FaEdit />
                            </Button>
                            {/* </LinkContainer> */}
                          </td>
                          <td style={{ padding: "0px" }}>
                            <Button
                              className="btn-sm"
                              variant="danger"
                              // onClick={() => handleDelete(passport._id)}
                              disabled
                            >
                              <MdDelete />
                            </Button>
                          </td>
                        </>
                      )}
                    </tr>
                  </>
                ))}
              </tbody>
            </Table>
          </Card>
        </Row>
      </>
      {/* )}
      </> */}
    </Container>
  );
};

export default VisaList;
